import React from 'react';

import { ForgotPasswordForm } from './components/ForgotPasswordForm';

export const ForgotPassword: React.FC = () => <ForgotPasswordForm />
